import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from 'react'
import { FiChevronDown, FiFilter, FiCheck } from 'react-icons/fi'
import './dropDownList.css'

const FILTER_OPTIONS = [
  { value: null, label: 'Без фильтров' },
  { value: 'Школа', label: 'Школа' },
  { value: 'Детский сад', label: 'Детский сад' },
  { value: 'Многоэтажки', label: 'Многоэтажки' }
]

const DropDownList = forwardRef((props, ref) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedValue, setSelectedValue] = useState(null)

  const toggleDropdown = (event) => {
    event.stopPropagation()
    setIsOpen((prev) => !prev)
  }

  const containerRef = useRef(null)

  const handleFilter = (option, event) => {
    event?.stopPropagation()
    if (option.value === null) {
      props.onFilter(props.startData)
    } else {
      const filteredResults = props.data.filter((item) => item.Type === option.value)
      props.onFilter(filteredResults)
    }

    setSelectedValue(option.value)
    setIsOpen(false)
  }

  const buttonRef = useRef(null)

  useEffect(() => {
    if (!isOpen) return
    const handleClickOutside = (event) => {
      if (!containerRef.current) return
      if (!containerRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isOpen])

  useImperativeHandle(ref, () => ({
    closeDropdown() {
      setIsOpen(false)
    }
  }))

  const activeLabel =
    FILTER_OPTIONS.find((option) => option.value === selectedValue)?.label || 'Тип проекта'

  return (
    <div ref={containerRef} className={`filter-dropdown ${isOpen ? 'is-open' : ''}`}>
      <button
        ref={buttonRef}
        type="button"
        className="filter-dropdown__toggle"
        onClick={toggleDropdown}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        <FiFilter className="filter-dropdown__leading" aria-hidden="true" />
        <span>{activeLabel}</span>
        <FiChevronDown
          className={`filter-dropdown__chevron ${isOpen ? 'is-open' : ''}`}
          aria-hidden="true"
        />
      </button>

      <ul
        className="filter-dropdown__menu"
        role="listbox"
        aria-activedescendant={selectedValue ?? 'all-projects'}
      >
        {isOpen
          ? FILTER_OPTIONS.map((option) => {
              const isActive = selectedValue === option.value
              const optionId = option.value ?? 'all-projects'

              return (
                <li key={option.label} id={optionId} role="option" aria-selected={isActive}>
                  <button
                    type="button"
                    className={`filter-dropdown__option ${isActive ? 'is-active' : ''}`}
                    onClick={(e) => handleFilter(option, e)}
                  >
                    <span>{option.label}</span>
                    {isActive ? <FiCheck aria-hidden="true" /> : null}
                  </button>
                </li>
              )
            })
          : null}
      </ul>
    </div>
  )
})

export default DropDownList